import firebase from "firebase";

class AuthService {
  constructor() {
    this.log = 'Service created';
  }
adminLogin = async(email, password)=> {
  try{
    await firebase.auth().signInWithEmailAndPassword(email, password);
    return true;
  }
  catch(error){
    return error;
  }
}
}
export {
  AuthService
};
